import React from 'react'
import SolutionHero from '../hero/solutionHero'
import NewsroomFeatured from '../newsroomFeatured'
import SolutionsPush from '../solutions/solutionsPush'
import SlicesWrapper from '../slices/slicesWrapper'

const SolutionLayout = ({data, currentUrl, news, events, socials, solutions, lang}) => {
  return (
    <>
      <SolutionHero 
        currentUrl={currentUrl}
        data={data} />

      <div>
        <SlicesWrapper slices={data.slices} lang={lang} />
      </div>
      
      <NewsroomFeatured news={news} events={events} socials={socials} lang={lang} />
      <SolutionsPush solutions={solutions} type="inner" lang={lang} />
    </>
  )
}

export default SolutionLayout